import { Link } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { logEvent } from "@src/appV2/lib/analytics/log";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { SystemInlineBanner, Text } from "@src/appV2/redesign/system/ui-components";

interface PostBookingSupportBannerProps {
  workplaceId: string;
  shiftId: string;
  qualification: string | undefined;
}

export function PostBookingSupportBanner(props: PostBookingSupportBannerProps) {
  const { workplaceId, shiftId, qualification } = props;

  useLogEffect(APP_V2_USER_EVENTS.POST_BOOKING_DOCUMENTS_LIST_BANNER_SHOWN, {
    workplaceId,
    shiftId,
    qualification,
  });

  const handleContactSupport = () => {
    logEvent(APP_V2_USER_EVENTS.POST_BOOKING_DOCUMENTS_LIST_SUPPORT_CLICKED, {
      workplaceId,
      shiftId,
      qualification,
    });
    void openZendeskMessaging();
  };

  return (
    <SystemInlineBanner color="neutral" iconType="info" sx={{ marginX: 5, marginBottom: 4 }}>
      <Text inline variant="body2" color="inherit">
        If you need help,{" "}
        <Link
          component="button"
          type="button"
          sx={{ color: "inherit", font: "inherit", verticalAlign: "baseline" }}
          onClick={handleContactSupport}
        >
          contact support
        </Link>
        .
      </Text>
    </SystemInlineBanner>
  );
}
